import {
  Form,
  Input,
  Modal,
  ModalProps,
  FormProps,
  Select,
  Radio,
} from "@pankod/refine-antd";
import { useSelect } from "@pankod/refine-antd";
import { SubCatalog } from "interfaces";

type Props = {
  formProps: FormProps;
  modalProps: ModalProps;
};

interface SuperCategoryFormValues {
  name: string;
  subCatalog: string;
  order: string;
  isVisible: boolean;
}

export const CreateSuperCategory: React.FC<Props> = ({
  formProps,
  modalProps,
}) => {
  const { selectProps: subCatalogSelectProps } =
    useSelect<SubCatalog.SubCatalogItem>({
      resource: "subcatalog",
      optionLabel: "name",
      optionValue: "id",
      defaultValue: undefined,
    });

  const onFinish = async (values: SuperCategoryFormValues) => {
    const formattedValues = {
      ...values,
      order: values.order ? parseInt(values.order, 10) : undefined,
    };
    return formProps.onFinish?.(formattedValues);
  };

  return (
    <Modal
      {...modalProps}
      title="Yeni Süper Kategori Oluştur"
      width={400}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ isVisible: true }}
      >
        <Form.Item
          label="İsim"
          name="name"
          rules={[
            {
              required: true,
              message: "İsim boş olamaz.",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Alt Katalog"
          name="subCatalog"
          rules={[
            {
              required: true,
              message: "Alt katalog seçimi zorunludur.",
            },
          ]}
        >
          <Select
            {...subCatalogSelectProps}
            placeholder="Alt katalog seçin"
            allowClear={false}
          />
        </Form.Item>

        <Form.Item
          label="Gösterim Sırası"
          name="order"
        >
          <Input type="number" min={0} />
        </Form.Item>

        <Form.Item
          label="Durum"
          name="isVisible"
          rules={[
            {
              required: true,
              message: "Durum seçiniz.",
            },
          ]}
        >
          <Radio.Group
            options={[
              { label: "Aktif", value: true },
              { label: "Pasif", value: false },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
